module.exports = __webpack_public_path__ + "static/mondelez-2dbf39bf26c83837f355ea29e7f61c85.png";